const loyaltyConstants = {
	vipTiers: {
		currentStatusLabel: "current status",
		benefitHeaders: [
			"Perk 1",
			"Perk 2",
			"Perk 3",
			"Perk 4",
			"Perk 5"
		],
		benefitHeadersTitle: "Benefits",
		benefitsList: [
			{
				tierId: 4033,
				tierRequirement: "Spend $1",
				benefits: [
					"●",
					"●",
					" ",
					" ",
					" "
				]
			},		

            {
				tierId: 4034,
				tierRequirement: "Spent: $100",
				benefits: [
					"●",
					"●",
					"●",
					" ",
					" "
				]
			},		

            {
				tierId: 4035,
				tierRequirement: "Spent: $500",
				benefits: [
					"●",
					"●",
					"●",
					"●",
					"●"
				]
			}	
			


		]

	}
	
}
